import { render } from "./icons-map-marker.svg?vue&type=template&id=040487d4?inline"
const script = {}
script.render = render

export default script